import {
    v4 as uuid_v4
} from "uuid";
import formatearFecha from "../../mixins/formatearFecha";
import axios from "axios"

class Pack {
    constructor(pack) {
        this.asiento = (pack && pack.asiento) ? pack.asiento : null;
        this.cliente = (pack && pack.cliente) ? pack.cliente : null;
        this.cliente_id = (pack && pack.cliente_id) ? pack.cliente_id : null;
        this.contrato = (pack && pack.contrato) ? pack.contrato.contrato : null;
        this.contrato_id = (pack && pack.contrato) ? pack.contrato.id : null;
        this.fechaCierre = (pack && pack.fechaCierre) ? formatearFecha.methods.crearFecha('Y-m-d', pack.fechaCierre) : null;
        this.fechaRegistro = (pack && pack.fechaRegistro) ? formatearFecha.methods.crearFecha('Y-m-d', pack.fechaRegistro) : null;
        this.horasContratadas = (pack && pack.horasContratadas) ? pack.horasContratadas : 0;
        this.id = (pack && pack.id) ? pack.id : uuid_v4();
        this.nDoc = (pack && pack.nDoc) ? pack.nDoc : 'Creado manualmente';
        this.observaciones = (pack && pack.observaciones) ? pack.observaciones : null;
    }

    setFecha(fecha) {
        this.fechaRegistro = fecha;
    }
    setCliente(cliente) {
        this.cliente = cliente.text
        this.cliente_id = cliente.value
    }
    setContrato(contrato) {
        this.contrato_id = contrato.value
        this.contrato = contrato.text
    }
    getCliente() {
        return {
            value: this.cliente_id,
            text: this.cliente
        }
    }
    getContrato() {
        return {
            value: this.contrato_id,
            text: this.contrato
        }
    }
    esNuevoPack() {
        return (typeof (this.id) !== "number");
    }
    getId() {
        return this.id
    }
    setId(id) {
        this.id = id
    }
    getObject() {
        return {
            'cliente_id': this.cliente_id,
            'cliente': this.cliente,
            'fechaRegistro': this.fechaRegistro,
            'contrato_id': this.contrato_id,
            'horasContratadas': this.horasContratadas,
            'nDoc': "CREADO MANUALMENTE",
            'observaciones': this.observaciones
        }
    }
    getPack() {
        return {
            'id': this.id,
            'asiento': this.asiento,
            'cliente_id': this.cliente_id,
            'cliente': this.cliente,
            'fechaRegistro': /* formatearFecha.methods.formatDate( */ this.fechaRegistro /* ) */ ,
            'fechaCierre': this.fechaCierre,
            'contrato_id': this.contrato_id,
            'contrato.contrato': this.contrato,
            'horasContratadas': this.horasContratadas,
            'nDoc': "CREADO MANUALMENTE",
            'observaciones': this.observaciones
        }
    }
}

export default Pack;